module.exports = __webpack_public_path__ + "static/media/hosting.7b72ec79.svg";